import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { useUserStore } from "@/stores/user";
import { onMounted } from "vue";
import Loader from "@/components/util/Loader.vue";
import { VueFinalModal } from "vue-final-modal";
import UserProjectTable from "../tables/UserProjectTable.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProjectsModal',
  props: ['userId'],
  setup(__props) {

const props = __props;

const userStore = useUserStore();

onMounted(async () => {
    await userStore.loadProjectsForUser(props.userId);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: true
  }, {
    default: _withCtx(() => [
      (_unref(userStore).getUserProjectsLoaded)
        ? (_openBlock(), _createBlock(UserProjectTable, {
            key: 0,
            projects: _unref(userStore).getUserProjects
          }, null, 8, ["projects"]))
        : (_openBlock(), _createBlock(Loader, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})